﻿import { IInputScope, KbInput } from "@app/components/kb-input/kb-input.component";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { Dirs } from "@app/helpers/dirs";
import { Utils } from "@tools";

export interface IRadioScope extends IInputScope {
    // external members
    source: any;
    valueField: string;
    labelField: string;
    /** custom data that can be passed in and accessed by the transcluded content for the select items */
    data: any;
    
    _id: string;
    _getItemValue: (item: any) => any;
    _select: (item: any) => void;
    _itemKeydown: (e: JQuery.Event, item: any) => void;
}

export interface IRadioController {
    scope: IRadioScope;
}

@NgComponent({
    token: Token.KbRadio,
    dependencies: [
        Token.$Timeout,
    ]
})
export class KbRadio extends KbInput {
    constructor(
        $timeout: ng.ITimeoutService
    ) {
        super($timeout);
        this.scope = Utils.extend(this.scope, {
            source: "=",
            valueField: "@",
            labelField: "@",
            data: "=?"
        });
        this.transclude = true;
        this.template = Dirs.component("kb-radio");

        this.link = (scope: IRadioScope, element: JQuery, atts, controllers: any[]) => {
            this.kbInputLinkFn(scope, element, atts, controllers, false);
            let ngModel = controllers[0];

            scope._id = Utils.shortId();
           
            scope._getItemValue = (item: any) => {
                if (item === null || item === undefined) return null;
                return scope.valueField ? item[scope.valueField] : item;
            };
            scope._select = (item: any) => {
                if (!scope.ngDisabled) {
                    ngModel.$setViewValue(scope._getItemValue(item));
                }
            };

            scope._itemKeydown = (e: JQuery.Event, item) => {
                if (e.key == 'Enter' || e.key == ' ' && !scope.ngDisabled) {
                    scope._select(item);
                    e.preventDefault();
                }
                else if (e.key == 'Escape') {
                    // element.find("input").blur();
                    element.find(".kb-radio__item").trigger('blur');
                }
            };
        };
    }
}